import { Box, Grid, Typography } from '@mui/material';
import { FC } from 'react';

import { FormikCheckboxField } from '../../../components/FormikCheckboxField';
import { FormikSelect } from '../../../components/formikInputs/FormikSelect';
import { FormikTextField } from '../../../components/formikInputs/FormikTextField';
import { FormikKundeAutocomplete } from '../../kunde/components/kundeAutocomplete/FormikKundeAutocomplete';
import { RechnungsZyklus } from '../api/projekt.types';

export const ProjektStammdatenFormElement: FC = () => {
  return (
    <>
      <Typography sx={{ mb: 2 }}>Stammdaten</Typography>
      <Grid container spacing={2}>
        <Grid size={6}>
          <FormikTextField
            name="name"
            textFieldProps={{ label: 'Projektname', fullWidth: true, required: true }}
          />
        </Grid>
        <Grid size={6}>
          <FormikKundeAutocomplete name={'kundeId'} required />
        </Grid>
        <Grid size={12}>
          <FormikTextField
            name="kurzbeschreibung"
            textFieldProps={{ label: 'Kurzbeschreibung', fullWidth: true }}
          />
        </Grid>
        <Grid size={6} sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ pl: 2 }}>
            <FormikCheckboxField name={'istPauschal'} label={'Pauschal'} />
          </Box>
          <Box sx={{ pl: 2 }}>
            <FormikCheckboxField name={'istArchiviert'} label={'Archiviert'} />
          </Box>
          <Box sx={{ pl: 2 }}>
            <FormikCheckboxField name={'istPausiert'} label={'Pausiert'} />
          </Box>
        </Grid>
        <Grid size={6}>
          <FormikSelect
            label={'Rechnungszyklus'}
            name={'rechnungszyklus'}
            options={[
              { value: RechnungsZyklus.EINMALIG, label: 'Einmalig' },
              { value: RechnungsZyklus.MONATLICH, label: 'Monatlich' },
              { value: RechnungsZyklus.QUARTALSWEISE, label: 'Quartalsweise' },
              { value: RechnungsZyklus.JAEHRLICH, label: 'Jährlich' },
            ]}
          />
        </Grid>
        <Grid size={12}>
          <FormikTextField
            name="bemerkung"
            textFieldProps={{ label: 'Bemerkung', fullWidth: true, multiline: true }}
          />
        </Grid>
      </Grid>
    </>
  );
};
